import i18next from 'i18next'
import { match } from 'ts-pattern'

import type { TradeSettingsQuick } from '@root/entities/trade-settings/model'

export const getQuickBuySectionLabel = (
  section: TradeSettingsQuick.QuickSwapSection,
): string =>
  match(section)
    .with('exploreFeeds', () =>
      i18next.t('trade-settings.quick-buy.section.explore-feeds'),
    )
    .with('trendingTable', () =>
      i18next.t('trade-settings.quick-buy.section.trending'),
    )
    .with('cookingTable', () =>
      i18next.t('trade-settings.quick-buy.section.cooking'),
    )
    .with('newPairsTable', () =>
      i18next.t('trade-settings.quick-buy.section.new-pairs'),
    )
    .with('walletsTracker', () =>
      i18next.t('trade-settings.quick-buy.section.wallet-tracker'),
    )
    .exhaustive()
